<section class="p-3">

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h1 mat-dialog-title><span i18n>Upozornenia</span></h1>

  <hr/>

  <mat-dialog-content class="mat-typography">

    <div class="flex-grow-1">
      <ul class="p-2 m-2">
        <li class="mb-2" *ngFor="let u of data">
          {{u.text}}
          <ul>
            <li><b>{{u.odDatumu}} - {{u.doDatumu}}</b></li>
            <li *ngIf="u.popis">{{u.popis}}</li>
          </ul>
        </li>
      </ul>
    </div>

  </mat-dialog-content>

  <hr>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>



